import CyrillicToTranslit from 'cyrillic-to-translit-js';

const cyrillicToTranslit = CyrillicToTranslit();

const toLatin = (text, locale) => {
  if (!text) {
    return '';
  }

  let result;

  switch (locale) {
  case 'ru':
    result = cyrillicToTranslit.transform(text);
    break;
  default:
    result = text;
    break;
  }

  return result;
};

const toLink = (text, locale) => {
  if (!text) {
    return '';
  }

  return toLatin(text.toLocaleLowerCase(locale), locale)
    .trim()
    .replace(/é/g, 'e')
    .replace(/ê/g, 'e')
    .replace(/è/g, 'e')
    .replace(/ë/g, 'e')
    .replace(/à/g, 'a')
    .replace(/á/g, 'a')
    .replace(/æ/g, 'a')
    .replace(/â/g, 'a')
    .replace(/î/g, 'i')
    .replace(/í/g, 'i')
    .replace(/ì/g, 'i')
    .replace(/ï/g, 'i')
    .replace(/ô/g, 'o')
    .replace(/ó/g, 'o')
    .replace(/ò/g, 'o')
    .replace(/œ/g, 'o')
    .replace(/ş/g, 's')
    .replace(/ı/g, 'i')
    .replace(/ç/g, 'c')
    .replace(/ğ/g, 'g')
    .replace(/ö/g, 'o')
    .replace(/ü/g, 'u')
    .replace(/ù/g, 'u')
    .replace(/û/g, 'u')
    .replace(/ú/g, 'u')
    .replace(/ÿ/g, 'y')
  // Arabic
    .replace(/ء/, 'e')
    .replace(/آ/, 'a')
    .replace(/أ/, 'a')
    .replace(/ؤ/, 'w')
    .replace(/إ/, 'i')
    .replace(/ئ/, 'y')
    .replace(/ا/, 'a')
    .replace(/ب/, 'b')
    .replace(/ة/, 't')
    .replace(/ت/, 't')
    .replace(/ث/, 'th')
    .replace(/ج/, 'j')
    .replace(/ح/, 'h')
    .replace(/خ/, 'kh')
    .replace(/د/, 'd')
    .replace(/ذ/, 'dh')
    .replace(/ر/, 'r')
    .replace(/ز/, 'z')
    .replace(/س/, 's')
    .replace(/ش/, 'sh')
    .replace(/ص/, 's')
    .replace(/ض/, 'd')
    .replace(/ط/, 't')
    .replace(/ظ/, 'z')
    .replace(/ع/, 'e')
    .replace(/غ/, 'gh')
    .replace(/ـ/, '-')
    .replace(/ف/, 'f')
    .replace(/ق/, 'q')
    .replace(/ك/, 'k')
    .replace(/ل/, 'l')
    .replace(/م/, 'm')
    .replace(/ن/, 'n')
    .replace(/ه/, 'h')
    .replace(/و/, 'w')
    .replace(/ى/, 'a')
    .replace(/ي/, 'y')
    .replace(/‎/, 'a')
    .replace(/'ُ/, 'u')
    .replace(/‎/, 'i')
    .replace(/٠/, '0')
    .replace(/١/, '1')
    .replace(/٢/, '2')
    .replace(/٣/, '3')
    .replace(/٤/, '4')
    .replace(/٥/, '5')
    .replace(/٦/, '6')
    .replace(/٧/, '7')
    .replace(/٨/, '8')
    .replace(/٩/, '9')
  // end of arabic
    // Urdu
    .replace(/ٹ/, 't')
    .replace(/ڈ/, 'd')
    .replace(/ڑ/, 'r')
    .replace(/ں/, 'n')
    .replace(/ہ/, 'h')
    .replace(/ھ/, 'h')
    .replace(/ے/, 'e')
    .replace(/پ/, 'p')
    .replace(/ژ/, 'z')
    .replace(/چ/, 'ch')
    // end of Urdu
    .replace(/ /g, '-')
    .replace(/[^a-z0-9-_]/g, '')
    .replace(/-{2,}/g, '-');
};

export default toLink;
